import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLike, pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {LabelPrimitivesOperatorParameters} from "#template/nodes/geometry-graph/attribute/label-primitives-operator/geometry-label-primitives-operator-node"
import {
    GeometryLabelPrimitivesOperatorNode,
    labelPrimitivesOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/label-primitives-operator/geometry-label-primitives-operator-node"

export type PointGeometryLabelPrimitivesOperatorParameters = LabelPrimitivesOperatorParameters<PointGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<PointGeometryLabelPrimitivesOperatorParameters> = {
    nodeClass: "PointGeometryLabelPrimitivesOperator",
    validation: {
        parameters: labelPrimitivesOperatorParametersSchema(pointGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryLabelPrimitivesOperator
    extends GeometryLabelPrimitivesOperatorNode<0, PointGeometryAttributeLikeNode>
    implements PointGeometryAttributeLikeNode
{
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
